import { render, staticRenderFns } from "./TipsTinder.vue?vue&type=template&id=887e79ea&"
import script from "./TipsTinder.vue?vue&type=script&lang=js&"
export * from "./TipsTinder.vue?vue&type=script&lang=js&"
import style0 from "./TipsTinder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports